import { render, staticRenderFns } from "./LinhaProdutoRoute.vue?vue&type=template&id=3fca48ea"
import script from "./LinhaProdutoRoute.vue?vue&type=script&lang=js"
export * from "./LinhaProdutoRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports